import { useState } from "react";
import { IoEyeOffOutline, IoEyeOutline } from "react-icons/io5";
const InputBox = ({
    label,
    type,
    name,
    value,
    onChange,
    id,
    placeholder,
    readOnly,
    required,
    onkeydown,
    maxlength,
    disabled
}) => {
    const [bool, setbool] = useState(false);
    return (
        <div class="form-floating">
            <input
                class="form-control"
                id={id}
                type={bool ? "text" : type}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                name={name}
                readOnly={readOnly}
                onKeyDown={onkeydown}
                maxLength={maxlength}
                autoComplete="off"
                disabled={disabled}
            />
            <label for="email">
                {label}
                {required && (<strong className={required ? "text-danger fs-9" : ""}>*</strong>)}
            </label>
            {type === "password" && value &&
                (bool ? (
                    <i
                        onClick={() => setbool(!bool)}
                        style={{
                            position: "absolute",
                            right: "5px",
                            top: "11px",
                        }}
                    >
                        <IoEyeOutline color="black" size={20} />
                    </i>
                ) : (
                    <i
                        onClick={() => setbool(!bool)}
                        style={{
                            position: "absolute",
                            right: "5px",
                            top: "11px",
                        }}
                    >
                        <IoEyeOffOutline color="black" size={20} />
                    </i>
                ))}
        </div>
    );
};
export default InputBox;